"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCachedLayoutType = createCachedLayoutType;
function createCachedLayoutType(layoutType) {
    return /** @class */ (function (_super) {
        __extends(CachedLayoutType, _super);
        function CachedLayoutType() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CachedLayoutType.prototype.createLayoutPassContext = function (options, availableSize, itemCount) {
            return __assign(__assign({}, _super.prototype.createLayoutPassContext.call(this, options, availableSize, itemCount)), { cache: {
                    itemSize: null,
                    fullContentSize: null,
                    itemRects: [],
                } });
        };
        CachedLayoutType.prototype.getItemSize = function (context) {
            if (context.cache.itemSize) {
                return context.cache.itemSize;
            }
            var size = _super.prototype.getItemSize.call(this, context);
            context.cache.itemSize = size;
            return size;
        };
        CachedLayoutType.prototype.getFullContentSize = function (context) {
            if (context.cache.fullContentSize) {
                return context.cache.fullContentSize;
            }
            var size = _super.prototype.getFullContentSize.call(this, context);
            context.cache.fullContentSize = size;
            return size;
        };
        CachedLayoutType.prototype.getItemRectAtIndex = function (context, itemIndex, item) {
            if (context.cache.itemRects[itemIndex]) {
                return context.cache.itemRects[itemIndex];
            }
            var itemRect = _super.prototype.getItemRectAtIndex.call(this, context, itemIndex, item);
            context.cache.itemRects[itemIndex] = itemRect;
            return itemRect;
        };
        CachedLayoutType.prototype.getItemRangeForRect = function (context, rect) {
            return _super.prototype.getItemRangeForRect.call(this, context, rect);
        };
        return CachedLayoutType;
    }(layoutType));
}
//# sourceMappingURL=CacheWrappedLayout.js.map